import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { configs } from '../../configs';
import styles from '../../styles/styles-desktop.css';

import { ButtonDecreaseComponent } from './button-decrease';
import type { TButton, IButtonDeps } from './models';

// Компоненту не требуется функционал стайлера
// eslint-disable-next-line styler/check-styler
export const ButtonDecreaseDesktop = createWidget<IButtonDeps, TButton>({
    configs,
    styles,
})(ButtonDecreaseComponent);
